'use client'

import { noop } from 'lodash'
import { createContext } from 'react'

import { HomepageTabModel } from '@marketplace-web/home/home-page-data'

export type HomeContextType = {
  homepageSessionId: string
  tabs: Array<HomepageTabModel>
  isLoading: boolean
  startTransition: (callback: () => void) => void
}

const HomeContext = createContext<HomeContextType>({
  // These fallback values will never be used, as the provider is required
  homepageSessionId: '',
  tabs: [],
  isLoading: false,
  startTransition: noop,
})

export default HomeContext
